import script from "./SettingsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsPanel.vue?vue&type=script&setup=true&lang=js"

import "./SettingsPanel.vue?vue&type=style&index=0&id=e95882a8&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e95882a8"]])

export default __exports__